import { Link } from "react-router-dom";
import { ConnectWallet } from "@thirdweb-dev/react";
import React, { useEffect, useState } from "react";
import { sdk } from "../lib/thirdweb";
import { ethers } from "ethers";

const CONTRACT_ADDRESS = "0x22336C29FEc84A3b882699488f798d5a10858B36";
const WEEP_TOKEN_ADDRESS = "0x120BbDd0F0b56c14878d0Bf5d91F744413904eC5"; // Ensure this is correct

export default function BasedHeader() {
  const [ethBalance, setEthBalance] = useState<string | null>(null);
  const [weepBalance, setWeepBalance] = useState<string | null>(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // Manage mobile menu visibility

  useEffect(() => {
    const fetchBalances = async () => {
      try {
        const provider = sdk.getProvider();

        // 🔹 Fetch ETH Balance
        const ethBalanceRaw = await provider.getBalance(CONTRACT_ADDRESS);
        // Format ETH balance to 4 decimal places
        setEthBalance(parseFloat(ethers.utils.formatEther(ethBalanceRaw)).toFixed(4));

        // 🔹 Fetch WEEP Token Balance
        const weepContract = await sdk.getContract(WEEP_TOKEN_ADDRESS);
        const weepBalanceRaw = await weepContract.call("balanceOf", [CONTRACT_ADDRESS]);

        console.log("Raw WEEP Balance:", weepBalanceRaw.toString());

        // Format WEEP balance to 2 decimal places
        setWeepBalance(parseFloat(ethers.utils.formatUnits(weepBalanceRaw, 18)).toFixed(2));
      } catch (error) {
        console.error("Error fetching balances:", error);
        setWeepBalance("Error");
      }
    };

    fetchBalances();
  }, []);

  return (
    <div className="overflow-x-hidden overflow-y-auto">
      <header className="w-full bg-black text-blue-400 py-4 px-8 fixed top-0 left-0 right-0 z-50 shadow-md shadow-blue-600">
        <nav className="flex justify-between items-center max-w-7xl mx-auto">
          <Link to="/" className="text-2xl font-bold text-blue-400 hover:text-white drop-shadow-[0_0_6px_rgba(59,130,246,0.8)]">
            Based Ponks
          </Link>

          <div className="hidden md:flex flex-col items-center bg-black/50 px-4 py-2 rounded-lg shadow-lg border border-purple-500">
            <h2 className="text-sm font-bold text-purple-400 mb-1">💰 Royalties Pool</h2>
            <div className="flex items-center space-x-4">
              <div className="relative w-6 h-6">
                <img src="https://basedponks.xyz/ponkimages/OIP.png" alt="ETH Coin" className="w-6 h-6 animate-coin-slow" />
              </div>
              <span className="text-sm text-gray-300">
                <span className="text-blue-400">{ethBalance ? `${ethBalance} ETH` : "Loading..."}</span>
              </span>
              <div className="relative w-6 h-6">
                <img src="https://basedponks.xyz/ponkimages/weepingplebs.jpg" alt="WEEP Coin" className="w-6 h-6 animate-coin-slow" />
              </div>
              <span className="text-sm text-gray-300">
                <span className="text-purple-400">{weepBalance !== null ? `${weepBalance} WEEP` : "Loading..."}</span>
              </span>
            </div>
          </div>

          {/* Burger Icon for Mobile */}
          <div className="sm:hidden flex items-center">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-blue-400 hover:text-white focus:outline-none"
            >
              <span className="block w-6 h-1 bg-blue-400 mb-1"></span>
              <span className="block w-6 h-1 bg-blue-400 mb-1"></span>
              <span className="block w-6 h-1 bg-blue-400"></span>
            </button>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6 text-lg overflow-x-auto">
          <Link to="/mint" className="text-blue-400 text-lg font-bold px-4 py-2 rounded-xl bg-black hover:bg-blue-500 transition-all duration-300 transform hover:scale-105">
  Mint Now
</Link>
            <Link to="/community" className="text-blue-400 hover:text-white drop-shadow-[0_0_6px_rgba(59,130,246,0.8)]">Community</Link>
            <Link to="/ponks" className="text-blue-400 hover:text-white drop-shadow-[0_0_6px_rgba(59,130,246,0.8)]">Ponks</Link>
            <Link to="/claim" className="text-blue-400 hover:text-white drop-shadow-[0_0_6px_rgba(59,130,246,0.8)]">Claim</Link>
            <Link to="/dashboard" className="text-blue-400 hover:text-white drop-shadow-[0_0_6px_rgba(59,130,246,0.8)]">Dashboard</Link>
            <ConnectWallet className="bg-gradient-to-r from-blue-500 to-purple-600 text-white font-bold py-2 px-4 rounded-xl hover:opacity-90 transition" />
          </div>
        </nav>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="sm:hidden flex flex-col items-center space-y-4 bg-black py-4 px-8">
            <Link to="/mint" className="text-blue-400 text-lg font-bold">Mint Now</Link>
            <Link to="/community" className="text-blue-400">Community</Link>
            <Link to="/ponks" className="text-blue-400">Ponks</Link>
            <Link to="/claim" className="text-blue-400">Claim</Link>
            <Link to="/dashboard" className="text-blue-400">Dashboard</Link>
            <ConnectWallet className="bg-gradient-to-r from-blue-500 to-purple-600 text-white font-bold py-2 px-4 rounded-xl hover:opacity-90 transition" />
          </div>
        )}
      </header>

      <style>
        {`
          @keyframes coin-slow-flip {
            0% { transform: rotateY(0deg); }
            45% { transform: rotateY(180deg); }
            50% { transform: rotateY(180deg); }
            95% { transform: rotateY(360deg); }
            100% { transform: rotateY(360deg); }
          }
          .animate-coin-slow {
            animation: coin-slow-flip 4s ease-in-out infinite;
          }
        `}
      </style>
    </div>
  );
}
